import React, { useEffect, createElement } from 'react';
import { Button } from './ui/Button';
import { Mail, Phone, Clock } from 'lucide-react';
export function Contact() {
  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://static.hsappstatic.net/MeetingsEmbed/ex/MeetingsEmbedCode.js';
    script.async = true;
    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
    };
  }, []);
  return <section id="contact" className="py-24 bg-[#FAFAFA]" data-id="element-28">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-29">
        <div className="grid lg:grid-cols-2 gap-16" data-id="element-30">
          {/* HubSpot Meeting Embed */}
          <div className="bg-white p-8 rounded-2xl border border-neutral-200 min-h-[600px]" data-id="element-31">
            <h2 className="text-3xl font-semibold text-black mb-6" data-id="element-32">
              Projekt anfragen
            </h2>
            <div className="meetings-iframe-container" data-src="https://meetings-eu1.hubspot.com/christopher52?embed=true" data-id="element-33"></div>
          </div>

          {/* Contact Info */}
          <div className="flex flex-col justify-center space-y-8" data-id="element-34">
            <div data-id="element-35">
              <h3 className="text-2xl font-semibold text-black mb-4" data-id="element-36">
                Kontaktieren Sie uns
              </h3>
              <p className="font-light text-neutral-500 text-lg leading-relaxed" data-id="element-37">
                Wir helfen Ihnen gerne dabei, Ihre Immobilienprojekte optimal zu
                präsentieren. Schreiben Sie uns oder rufen Sie an.
              </p>
            </div>

            <div className="space-y-6" data-id="element-38">
              <div className="flex items-start gap-4" data-id="element-39">
                <div className="w-10 h-10 rounded-full bg-neutral-100 border border-neutral-200 flex items-center justify-center flex-shrink-0" data-id="element-40">
                  <Mail className="w-5 h-5 text-black" data-id="element-41" />
                </div>
                <div data-id="element-42">
                  <p className="font-medium text-black" data-id="element-43">Email</p>
                  <a href="mailto:hallo@archaitechs.de" className="font-light text-neutral-500 hover:text-black transition-colors" data-id="element-44">
                    hallo@archaitechs.de
                  </a>
                </div>
              </div>

              <div className="flex items-start gap-4" data-id="element-45">
                <div className="w-10 h-10 rounded-full bg-neutral-100 border border-neutral-200 flex items-center justify-center flex-shrink-0" data-id="element-46">
                  <Phone className="w-5 h-5 text-black" data-id="element-47" />
                </div>
                <div data-id="element-48">
                  <p className="font-medium text-black" data-id="element-49">Telefon</p>
                  <p className="font-light text-neutral-500" data-id="element-50">
                    +49 (0) 30 123 456 78
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4" data-id="element-51">
                <div className="w-10 h-10 rounded-full bg-neutral-100 border border-neutral-200 flex items-center justify-center flex-shrink-0" data-id="element-52">
                  <Clock className="w-5 h-5 text-black" data-id="element-53" />
                </div>
                <div data-id="element-54">
                  <p className="font-medium text-black" data-id="element-55">Antwortzeit</p>
                  <p className="font-light text-neutral-500" data-id="element-56">
                    Wir antworten in der Regel innerhalb von 2 Stunden.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}